const black = {
	100: "#000000",
	200: "#121212",
	300: "#242424",
	400: "#373737",
	500: "#494949",
	600: "#5B5B5B",
	700: "#6D6D6D",
	800: "#808080",
};

const blue = {
	100: "#41B5C3",
};

const white = {
	100: "#FFFFFF",
	200: "#EDEDED",
	300: "#DBDBDB",
	400: "#D0D0D0",
	500: "#B6B6B6",
	600: "#A4A4A4",
	700: "#929292",
	800: "#808080",
};

const yellow = {
	100: "#B99308",
	200: "#CCA208",
	300: "#DEB009",
	400: "#F1BF0A",
	500: "#F5C518",
	600: "#F7CE3A",
	700: "#F8D65B",
	800: "#FADE7C",
};

const shadow = {
	box: "#00000020",
	hover: "#00000032",
	slider: "#F5C51829",
};

const colors = {
	black,
	white,
	yellow,
	shadow,
	blue,
	secondary: black[500],
	primary: "#41b5c3",
	danger: "#d32f2f",
};

const typography = {
	impact: {
		regular: "Impact Regular",
	},
	roboto: "Roboto,Helvetica,Arial,sans-serif",
};

const breakpoints = {
	sm: 480,
	md: 768,
	lg: 1024,
	xl: 1200,
	xxl: 1400,
};

const theme = {
	colors,
	typography,
	breakpoints,
};

export default theme;
